import {Model} from './model';

export class EndCustomerContact implements Model {
  endCustomerContactId: number;
  endCustomerId: number;
  name: string;
  phone: string;
  email: string;

  static copy(oldObj: EndCustomerContact): EndCustomerContact {
    const newObj = new EndCustomerContact();
    newObj.endCustomerContactId = oldObj.endCustomerContactId;
    newObj.endCustomerId = oldObj.endCustomerId;
    newObj.name = oldObj.name;
    newObj.phone = oldObj.phone;
    newObj.email = oldObj.email;
    return newObj;
  }

  public getPrimaryKey(): number {
    return this.endCustomerContactId;
  }

  isNew(): boolean {
    return isNaN(this.endCustomerContactId);
  }

  clone(): EndCustomerContact {
    return EndCustomerContact.copy(this);
  }
}
